import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css' // ✅ ЭНЭ МӨР ХАМГИЙН ЧУХАЛ (CSS холбож байна)
import 'leaflet/dist/leaflet.css'

// Environment validation and Sentry initialization
import { validateEnv } from './lib/env'
import { initSentry } from './lib/sentry'
import { reloadOnceForStaleChunks } from './lib/stale-chunk'

// A new deploy replaces the hashed JS chunks this tab was built against. When a
// lazy route then fails to load (the missing chunk comes back as index.html),
// Vite fires `vite:preloadError` — reload once to pick up the fresh chunk map.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  reloadOnceForStaleChunks()
})

// Validate environment variables before app starts
// This prevents silent failures due to missing configuration
validateEnv()

// Initialize Sentry error tracking
// Only enabled in production or when VITE_SENTRY_ENABLED=true
initSentry()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2,
      gcTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
    },
  },
})

const root = document.getElementById('root')
if (!root) {
  throw new Error('Root element not found')
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)
